var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lego-block"},[(_vm.ignoreBlock)?void 0:[(!_vm.isCMS && _vm.componentId)?_c(_vm.componentId,{ref:"comp",tag:"component",attrs:{"data":_vm.tmplData,"tmplId":_vm.tmplId},on:{"compAction":_vm.onCompAction}}):_vm._e(),(_vm.isCMS)?_c('CmsBlock',{attrs:{"code":_vm.settings.label,"name":_vm.name,"data":_vm.settings}}):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }